import { render, staticRenderFns } from "./LuckyBag.vue?vue&type=template&id=1b7b8903&scoped=true"
import script from "./LuckyBag.vue?vue&type=script&lang=js"
export * from "./LuckyBag.vue?vue&type=script&lang=js"
import style0 from "./LuckyBag.vue?vue&type=style&index=0&id=1b7b8903&prod&scoped=true&lang=scss"
import style1 from "./LuckyBag.vue?vue&type=style&index=1&id=1b7b8903&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7b8903",
  null
  
)

export default component.exports